import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./index.css";
import routes from "./routes/routeDefinitions";

import Home from "./pages/home/home";
import NotFound from "./pages/404/404";
import Suppliers from "./pages/suppliers/Suppliers";
import Contact from "./pages/contact/Contact";
import About from "./pages/about/About";
import Privacy from "./pages/privacy/Privacy";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<Home />} />

        <Route path={routes.suppliers.path} element={<Suppliers />} />

        <Route path={routes.contact.path} element={<Contact />} />

        <Route path={routes.about.path} element={<About />} />

        <Route path={routes.privacy.path} element={<Privacy />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  </BrowserRouter>,

  document.getElementById("root")
);
